module.exports = __webpack_public_path__ + "img/机器人行业结构示意图.d68650a6.jpg";